export const mappedReducer = (eventsMap) => (state, event, exec) => eventsMap[event.type](state, event, exec);
